export const notifications = ["error", "info", "success"];
export const locale = "ru";
export const logger = {
  senders: [],
  enabled: process.env.NODE_ENV !== "production"
};
